export const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-background text-foreground">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Company:</strong> Realise Property Maintenance Ltd. trading as "Sortable"
        </p>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          <strong>Telephone:</strong> 08000438880
        </p>
        <p className="text-sm text-muted-foreground">
          <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
        </p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
          <p className="mb-3">
            These Terms and Conditions ("Terms") govern your use of the Sortable platform operated by 
            Realise Property Maintenance Ltd. ("we," "us," or "our"). By accessing or using our service, 
            you agree to be bound by these Terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Service Description</h2>
          <p className="mb-3">
            Sortable is a digital platform that connects customers with qualified tradespeople for 
            property maintenance and repair services. We act as an intermediary between customers 
            seeking services and tradespeople offering those services.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. User Accounts</h2>
          <div className="space-y-2">
            <p>3.1. You must create an account to access certain features of our service.</p>
            <p>3.2. You are responsible for maintaining the confidentiality of your account credentials.</p>
            <p>3.3. You must provide accurate and complete information when creating your account.</p>
            <p>3.4. You must be at least 18 years old to create an account.</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. For Customers</h2>
          <div className="space-y-2">
            <p>4.1. You may post job requests for property maintenance services.</p>
            <p>4.2. You are responsible for providing accurate job descriptions and requirements.</p>
            <p>4.3. Payment for services is due according to the agreed terms with the tradesperson.</p>
            <p>4.4. You must allow reasonable access to your property for the work to be completed.</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. For Tradespeople</h2>
          <div className="space-y-2">
            <p>5.1. You must have appropriate qualifications and insurance for the services you offer.</p>
            <p>5.2. You must provide accurate information about your skills and experience.</p>
            <p>5.3. You are responsible for completing work to professional standards.</p>
            <p>5.4. You must comply with all relevant health and safety regulations.</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Payments and Fees</h2>
          <div className="space-y-2">
            <p>6.1. Payment arrangements are between customers and tradespeople.</p>
            <p>6.2. We may charge service fees as displayed on our platform.</p>
            <p>6.3. All fees are non-refundable unless otherwise stated.</p>
            <p>6.4. Prices include VAT where applicable.</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Liability and Insurance</h2>
          <div className="space-y-2">
            <p>7.1. We are not liable for the quality of work performed by tradespeople.</p>
            <p>7.2. Tradespeople must maintain appropriate public liability insurance.</p>
            <p>7.3. Our liability is limited to the maximum extent permitted by law.</p>
            <p>7.4. We do not guarantee the availability or reliability of our service.</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Intellectual Property</h2>
          <p className="mb-3">
            All content on our platform, including text, graphics, logos, and software, is owned by 
            us or our licensors and is protected by intellectual property laws.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">9. Termination</h2>
          <div className="space-y-2">
            <p>9.1. We may suspend or terminate your account at any time for violation of these Terms.</p>
            <p>9.2. You may terminate your account by contacting us.</p>
            <p>9.3. Termination does not affect existing contractual obligations.</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">10. Governing Law</h2>
          <p className="mb-3">
            These Terms are governed by English law and subject to the exclusive jurisdiction of 
            English courts.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">11. Contact Information</h2>
          <div className="space-y-2">
            <p>For questions about these Terms, please contact us:</p>
            <p><strong>Email:</strong> info@sortable.co.uk</p>
            <p><strong>Phone:</strong> 08000438880</p>
            <p><strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN</p>
          </div>
        </section>
      </div>
    </div>
  );
};